(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .directive('fbFieldEmploymentTypeDetails', fbFieldEmploymentTypeDetails);

    function fbFieldEmploymentTypeDetails(lodash) {
        return {
            restrict: "EA",
            scope: {
                element: '=',
                eventHandler: '&',
            },
            require: 'ngModel',
            templateUrl: 'common/libraries/formBuilder/fields/fieldEmploymentTypeDetails',
            controller: fbFieldEmploymentTypeDetailsCtrl,
            controllerAs: 'vm',
            bindToController: true,
            link: function (scope, elem, attr, ctrl) {
                var vm = scope.vm;

                vm.events = {
                    add: add,
                    remove: remove,
                    getVisibility: getVisibility,
                };

                ctrl.$render = function (viewValue) {
                    vm.model = vm.setInitialModel(ctrl.$modelValue);
                };

                 vm.commitChange = function () {
                    ctrl.$setViewValue(vm.model);

                };

                function add() {
                    vm.model.push(vm.generateDefaultModel());
                    vm.commitChange();
                }

                function remove(rowData, $index) {
                    vm.model.splice($index, 1);
                    vm.commitChange();
                }

                function getVisibility(type, field) {
                    var type_visibility_setting = lodash.get(vm.element, 'options.fields_to_hide.' + type, null);
                    if (type_visibility_setting) {
                        return !(type_visibility_setting.indexOf(field) >= 0);
                    }
                    return false;
                }
            }
        };
    }

    function fbFieldEmploymentTypeDetailsCtrl(lodash, FormBuilderService, $scope, $timeout, $element, FbSelectService) {
        var vm = this;
        var formIdentifier = '';
        var source = [];
        var elementIdentifier = '';
        var fbService = null;
        var job_grade_select_settings = null;
        var working_hours_select_settings = null;
        var additionalOptions = {};
        var additionalOptionsWorkingHours = {};
        var cdnEp = '';
        this.$onInit = function() {
            vm.selectizes = null;
            formIdentifier = $scope.$parent.vm.formIdentifier;
            vm.model = [];
            source = lodash.get(vm, 'element.options.datasource.sel_employment_type', []);
            vm.max = source.length;

            vm.employmentTypeDs = {
            };

            elementIdentifier = $scope.$parent.vm.elementIdentifier;
            fbService = FormBuilderService.get(formIdentifier);
            FormBuilderService.sync(formIdentifier, vm);

            vm.hasError = hasError;
            vm.hasFieldError = hasFieldError;
            vm.fieldErrorMessage = fieldErrorMessage;
            vm.canRemove = canRemove;

            // $scope.$watch('vm.model', function(newValue, oldValue) {
            //     console.log(newValue);
            //     vm.commitChange();
            // }, true);

            vm.single_select_settings = {
                highlight: true,
                create: false,
                labelField: 'label',
                valueField: 'value',
                maxItems: 1,
                searchField: ['label']
            };

            vm.multi_select_settings = angular.copy(vm.single_select_settings);
            vm.multi_select_settings.maxItems = null;
            job_grade_select_settings = angular.copy(vm.single_select_settings);
            working_hours_select_settings = angular.copy(vm.multi_select_settings);

            FbSelectService.initTemplateCall(lodash.get(vm.element, 'options.job_grade', {}), additionalOptions);
            FbSelectService.initTemplateCall(lodash.get(vm.element, 'options.working_hours', {}), additionalOptionsWorkingHours);
            vm.job_grade_select_settings = angular.extend(job_grade_select_settings, additionalOptions,lodash.get(vm.element, 'options.job_grade.selectize', {}));
            vm.working_hours_settings = angular.extend(working_hours_select_settings, additionalOptionsWorkingHours,lodash.get(vm.element, 'options.working_hours.selectize', {}));

            /**

             */

            cdnEp = angular.element('div[data-cdn-ep]').attr('data-cdn-ep');
            vm.tinymceOptions = {
                plugins: 'link image autoresize paste lists table advlist visualblocks visualchars charmap',
                menubar: false,
                toolbar: 'undo redo | bold italic underline | bullist numlist | outdent indent',
                preview_styles: false,
                resize: true,
                statusbar: false,
                autoresize_bottom_margin: 0,
                autoresize_min_height: 50,
                debounce: false,
                content_css: cdnEp + '/assets/css/rms-tinymce.css',
                // paste_as_text: true,
                paste_data_images: false,
                setup: function (ed) {
                    ed.on('init', function (inst) {
                        $timeout(function () {
                            var container = angular.element(inst.target.editorContainer);
                            var em = container.find('.mce-toolbar-grp');
                            container.remove('.mce-toolbar-grp');
                            container.find('.mce-edit-area').after(em);
                        });
                    });
                },
                // paste_word_valid_elements: "b,strong,i,em,h1,h2,table,tr,td,ul,ol,li"
            };
            vm.employment_type_settings = angular.merge({}, vm.single_select_settings, {
                onFocus: function() {
                    var instance = this;
                    prepEmpType(instance);
                }
            });
        }

        function prepEmpType(selectizeInst) {
            var default_source = lodash.get(vm, 'element.options.datasource.sel_employment_type', []);
            var existing = vm.model.reduce(function(carry, rowData) {
                if (rowData.sel_employment_type) {
                    carry.push(rowData.sel_employment_type);
                }
                return carry;
            }, []);

            var current = selectizeInst.getValue();
            if (current) {
                lodash.pull(existing, current);
            }

            existing.map(function(_existing) {
                selectizeInst.removeOption(_existing);
            });
            default_source = lodash.filter(default_source, function(rowData) {
                var comparer = lodash.get(rowData, 'value', '').toString();
                 return existing.indexOf(comparer) < 0;
            });
            selectizeInst.addOption(default_source);
            selectizeInst.refreshOptions(false);
        }

        vm.setInitialModel = function (modelValue) {
            var result = (!modelValue) ? [] : modelValue;

            var min = lodash.get(vm, 'element.options.min', 0);
            while (result.length < min) {
                result.push(vm.generateDefaultModel());
            }
            return result;
        };

        vm.generateDefaultModel = function() {
            var _default = lodash.get(vm, 'element.options.default_value', {});
            return lodash.extend({}, _default);
        }

        vm.employmentTypeChange = function (modelIndex) {
            var employmentType = vm.model[modelIndex]['sel_employment_type'];
            var fieldsToHide = vm.element.options.fields_to_hide[employmentType];

            if (fieldsToHide.length > 0) {
                $timeout(function() {
                    vm.model[modelIndex] = lodash.omit(vm.model[modelIndex], fieldsToHide);
                });
            }
        }



        function hasError() {
            var error_rules = fbService.elementsService.getValidationRule(elementIdentifier);
            vm.error_messages = error_rules;
            return error_rules;
        }

        function hasFieldError(index, fieldname) {
            var error_rules = fbService.elementsService.getValidationRule(elementIdentifier);
            return lodash.has(error_rules, [index, fieldname].join('.'), false);
        }

        function fieldErrorMessage(index, fieldname) {
            var error_rules = fbService.elementsService.getValidationRule(elementIdentifier);
            return lodash.get(error_rules, [index, fieldname].join('.'), '');
        }

        function canRemove() {
            return vm.model.length > lodash.get(vm, 'element.options.min', 0);
        }
        //
        // function errorMessage() {
        //     var error = fbService.elementsService.getValidationRule(elementIdentifier);
        //     if (!error) {
        //         return '';
        //     }
        //     return error.join(' ');
        // }
    }
})();
